import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { AbstractComponent, Attendance, Contact, ContactService, LeadSource, Pager } from 'lib-trend-core';
import { Observable, takeUntil } from 'rxjs';
import { attendanceSelector, simpleLeadSourcesSelector } from '../../../state/selectors';
import { AppState } from '../../../state/app.state';
import { Store } from '@ngrx/store';
import { getAttendance } from '../../../state/actions';

@Component({
    selector: 'app-add-lead-source',
    // templateUrl: './add-lead-source.component.html',
    templateUrl: './add-lead-source.v2.component.html',
    styleUrl: './add-lead-source.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddLeadSourceComponent extends AbstractComponent implements OnInit {

  private readonly attendance$: Observable<Attendance> = this.store.select(attendanceSelector);
  private readonly leadesSource$: Observable<Array<LeadSource>> = this.store.select(simpleLeadSourcesSelector);

  pager: Pager<Contact> = new Pager<Contact>({ perPage: 3 });
  listObservable: Observable<Pager<Contact>>;

  leadSourceList: Array<LeadSource> = new Array<LeadSource>();
  leadSourceSelected: LeadSource = {} as LeadSource;
  contactLeadSource: LeadSource;

  contact: Contact;
  attendance: Attendance

  constructor(
    injector: Injector,
    private store: Store<AppState>,
    public contactService: ContactService,
  ) {
    super(injector);
    this.setuForm();
  }

  ngOnInit(): void {
    this.attendance$.pipe(takeUntil(this.destroy$)).subscribe((attendance: Attendance) => {
      this.attendance = attendance;
      this.contact = attendance?.contact;

      this.leadesSource$.pipe(takeUntil(this.destroy$)).subscribe(leadSources => {
        this.leadSourceList = leadSources

        this.contactLeadSource = this.getLeadSourceSelected(this.contact);
      });
    });
  }

  private setuForm(): void {
    this.formGroup = this.formBuilder.group({
      name: [null],
    });
  }

  onSelectLeadSource(event: MatSelectChange): void {
    const selected: LeadSource = event.value;

    if (selected) {
      this.leadSourceSelected = selected;
      this.formGroup.patchValue({ name: selected.name ?? '' });
      this.saveLeadSource(this.leadSourceSelected);
    }
  }

  saveLeadSource(leadSource: LeadSource): void {
    this.contactService.updateLeadSource(this.contact._id, leadSource)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (contact: Contact) => {
          this.contact = contact;
          this.store.dispatch(getAttendance({ idAttendance: this.attendance._id }));
        },
        error: (error) => {
        },
        complete: () => {
          this.alertService.success(this.t('attendance.leadSource.savedOk'));
          this.formGroup.reset();
        }
      });
  }

  deleteLeadSource(): void {
    this.contactService.removeLeadSource(this.contact._id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (contact: Contact) => {
          this.contact = contact;
          this.contactLeadSource = null;
          this.store.dispatch(getAttendance({ idAttendance: this.attendance._id }));
        },
        error: (error) => { },
        complete: () => {
          this.alertService.success(this.t('attendance.leadSource.removedOk'));
          this.formGroup.reset();
        }
      });
  }

  private getLeadSourceSelected(contact: Contact): LeadSource {
    if (!contact?.leadSource) return null;

    const leadSourceId = typeof contact.leadSource === 'string'
      ? contact.leadSource
      : contact.leadSource._id;

    return this.leadSourceList.find(leadSource => leadSource._id === leadSourceId) ?? null;
  }
}
